Date.prototype.format = function (format) {
    var o = {
        'M+': this.getMonth() + 1, //month
        'd+': this.getDate(), //day
        'h+': this.getHours(), //hour
        'm+': this.getMinutes(), //minute
        's+': this.getSeconds(), //second
        'q+': Math.floor((this.getMonth() + 3) / 3), //quarter
        S: this.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp('(' + k + ')').test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return format;
};
// 返回时间
export function getTime(time, format) {
    return new Date(time).format(format);
}
export function formatOrdertime(orderTime) {
    return orderTime ? orderTime.substring(0, 16).replace('T', ' ') : '';
}
export function user_type_list(state) {
    const statusMap = {
        super: '超级账户',
        admin: '普通管理员',
        user: '员工'
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function client_user_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        passed: '审核成功',
        failed: '审核失败',
        ban: '黑名单'
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function data_detail_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        receiving: '领取中',
        success: '领取成功',
        failed: '异常',
        not_enough: '余额不足/领取失败'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function payment_use_merchant_withdraw_list(state) {
    const statusMap = {
        yes: '使用商户提现',
        no: '使用企业提现'
    };
    return statusMap[state] ? statusMap[state] : '';
}

// 中国标准时间转为 年月日
export function newDate(time) {
    var date = new Date(time);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
}
export function dateTime1(time) {
                // 中国标准时间
                let date1 = time
                // 年
                let y = date1.getFullYear()
                // 月
                let m = date1.getMonth() + 1
                m = m < 10 ? ('0' + m) : m
                // 日
                let d = date1.getDate()
                d = d < 10 ? ('0' + d) : d
                // 时
                let h = date1.getHours()
                h = h < 10 ? ('0' + h) : h
                // 分
                let M = date1.getMinutes()
                M = M < 10 ? ('0' + M) : M
                // 秒
                let s = date1.getSeconds()
                s = s < 10 ? ('0' + s) : s
                let dateTime1 = y + '-' + m + '-' + d + ' ' + h + ':' + M + ':' + s;
                return dateTime1
}
export function yearM() {
    var currentDate = new Date();
    var y = currentDate.getFullYear();
    let m = currentDate.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    let date = y + '-' + m 
    return date
}
export function parseParmStr(parmStr) {
    if (parmStr.indexOf('?') != -1) {
        var index = parmStr.indexOf('?');
        var parms = {};
        parmStr = parmStr.substr(index + 1);
        let strs = parmStr.split('&'); //["userName=mona", "pwd=3"]

        for (var i = 0; i < strs.length; i++) {
            parms[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
    }
    return parms;
}
export function checkPhone(value) {
    var phone = value;
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
        return false;
    } else {
        return true;
    }
}




export function user_auth_modules_list() {
    return [
        { key: 'pda', value: 'pda' },
        { key: 'homepage', value: '首页' },
        { key: 'company', value: '公司' },
        { key: 'product', value: '产品' },
        { key: 'labelapply', value: '二维码申请' },
        { key: 'labeltracking', value: '标签' },
        { key: 'inbounddata', value: '入库明细' },
        { key: 'outbounddata', value: '出库明细' },
        { key: 'saleagent', value: '代理商管理' },
        { key: 'saleagentinventory', value: '代理商库存' },
        { key: 'store', value: '门店管理' },
        { key: 'storeinbounddata', value: '门店入库' },
        { key: 'saleagentch', value: '代理商串货统计' },
        { key: 'abnormalscanlabellog', value: '串货二维码明细' },
        { key: 'clientuser', value: '员工管理' },
        { key: 'labelquery', value: '二维码查询' },
        { key: 'storeorder', value: '门店订单' },
        { key: 'userorder', value: '消费者订单' },
        { key: 'goods', value: '商品列表' },
        { key: 'goodscategory', value: '商品分类' },
        { key: 'posterconfig', value: '海报配置' },
        { key: 'coverconfig', value: '封面配置' },
        { key: 'activityconfig', value: '活动配置' },
        { key: 'userarticle', value: '动态审核' },
        { key: 'user', value: '会员' },
   

     
    ];
}
export function order_invoice_type_list() {
    return [
        { key: 'not_used', value: '不使用' },
        { key: 'personal', value: '个人' },
        { key: 'enterprise', value: '企业' }
    ];
}
export function order_invoice_status_list() {
    return [
        { key: 'not_used', value: '不使用' },
        { key: 'not_invoiced', value: '未开票' },
        { key: 'invoiced', value: '已开票' }
    ];
}
export function search_is_active() {
    return [
        { key: 'true', value: '正常' },
        { key: 'false', value: '停用' }
    ];
}
export function monthList() {
    let list = [
        { key: '1月', value: '1' },
        { key: '2月', value: '2' },
        { key: '3月', value: '3' },
        { key: '4月', value: '4' },
        { key: '5月', value: '5' },
        { key: '6月', value: '6' },
        { key: '7月', value: '7' },
        { key: '8月', value: '8' },
        { key: '9月', value: '9' },
        { key: '10月', value: '10' },
        { key: '11月', value: '11' },
        { key: '12月', value: '12' },
    ]
    return list;
}
export function publicIsInteger(obj) {
    return Math.floor(obj) === obj;
}
export function publicToInteger(floatNum) {
    var ret = { times: 1, num: 0 };
    if (publicIsInteger(floatNum)) {
        ret.num = floatNum;
        return ret;
    }
    var strfi = floatNum + '';
    var dotPos = strfi.indexOf('.');
    var len = strfi.substr(dotPos + 1).length;
    var times = Math.pow(10, len);
    var intNum = parseInt(floatNum * times + 0.5, 10);
    ret.times = times;
    ret.num = intNum;
    return ret;
}
export function publicOperation(a, b, op, n) {
  
    var o1 = publicToInteger(a);
    var o2 = publicToInteger(b);
    var n1 = o1.num;
    var n2 = o2.num;
    var t1 = o1.times;
    var t2 = o2.times;
    var max = t1 > t2 ? t1 : t2;
    var result = null;
    switch (op) {
        case 'add':
           
            if (t1 === t2) {
                // 两个小数位数相同
                result = n1 + n2;
               
            } else if (t1 > t2) {
                // o1 小数位 大于 o2
                result = n1 + n2 * (t1 / t2);
              

            } else {
                // o1 小数位 小于 o2
                result = n1 * (t2 / t1) + n2;
             
            }
           
            return result / max;
        case 'subtract':
            if (t1 === t2) {
                result = n1 - n2;
            } else if (t1 > t2) {
                result = n1 - n2 * (t1 / t2);
            } else {
                result = n1 * (t2 / t1) - n2;
            }
            return result / max;
        case 'multiply':
            // alert( (n1 * n2) / (t1 * t2))
            result = (n1 * n2) / (t1 * t2); 
            // if (n) {
            //     return toFixed(result, n);
            // } else {
            //     return toFixed(result, 2);
            // }
            return result;
        case 'divide':
            result = (n1 / n2) * (t2 / t1);
            // 如果除数为0，返回/,防止出错
            if (b == 0) {
                return '/';
            } else {
                if (n) {
                    return toFixed(result, n);
                } else {
                    return toFixed(result, 2);
                }
            }
    }
}

// 加减乘除的四个方法
export function publicAdd(a, b, c) {
    return publicOperation(a, b, c);
}

// 两个浮点数求和
export function accAdd(num1, num2) {
    var r1, r2, m;
    try {
        r1 = num1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = num2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    // return (num1*m+num2*m)/m;
    return Math.round(num1 * m + num2 * m) / m;
}

// 两个浮点数相减
export function accSub(num1, num2) {
    var r1, r2, m;
    try {
        r1 = num1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = num2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = r1 >= r2 ? r1 : r2;
    return (Math.round(num1 * m - num2 * m) / m).toFixed(n);
}

// 两个浮点数相除
export function accDiv(num1, num2) {
    var t1, t2, r1, r2;
    try {
        t1 = num1.toString().split('.')[1].length;
    } catch (e) {
        t1 = 0;
    }
    try {
        t2 = num2.toString().split('.')[1].length;
    } catch (e) {
        t2 = 0;
    }
    r1 = Number(num1.toString().replace('.', ''));
    r2 = Number(num2.toString().replace('.', ''));
    return (r1 / r2) * Math.pow(10, t2 - t1);
}

// 两个浮点数相乘
export function accMul(num1, num2) {
    var m = 0,
        s1 = num1.toString(),
        s2 = num2.toString();
    try {
        m += s1.split('.')[1].length;
    } catch (e) {}
    try {
        m += s2.split('.')[1].length;
    } catch (e) {}
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
}

export function  mergeArraysByField(arr) {
    var map = {}, result = [];
    for(var i = 0; i < arr.length; i++){
        var ai = arr[i];
        if(!map[ai.label]){
            result.push({
                label: ai.label,
                attr: [ai.attr]
            });
            map[ai.label] = ai;
        }else{
            for(var j = 0; j < result.length; j++){
                var dj = result[j];
                if(dj.label == ai.label){
                    dj.attr.push(ai.attr);
                    break;
                }
            }
        }
    }
    return result
}

/** 数组去重
 * 思路：定义一个新数组，存放原数组的第一个元素，然后将原数组和新数组的元素对比，若不同则存放在新数组中
 * @param arr 需要去重的数组
 * @param t 根据 t 字段(指定)进行去重
 * @returns {*[]} 已去重后的数据
 */
//  export function  arrLIst(arr, t = "") {
//     const newArr = [arr[0]]
//     // 有指定字段
//     if (t) {
//       for (let i = 1; i < arr.length; i++) {
//         let repeat = false
//         for (let j = 0; j < newArr.length; j++) {
//           if (t && arr[i][t] === newArr[j][t]) {
//             repeat = true
//             break
//           }
//         }
//         if (!repeat) newArr.push(arr[i])
//       }
//     }
//     // 无指定字段
//     else {
//       for (let i = 1; i < arr.length; i++) {
//         let repeat = false
//         for (let j = 0; j < newArr.length; j++) {
//           if (arr[i] === newArr[j]) {
//             repeat = true
//             break
//           }
//         }
//         if (!repeat) newArr.push(arr[i])
//       }
//     }
//     return newArr
//   }
  export function  arrLIst (arr) {
    // 数组中对象去重
    let map = new Map()
    arr.forEach((item, index) => {
      if (!map.has(item['label','attr'])) {
        map.set(item['label','attr'], item)
      }
    })
   
    return [...map.values()]
  }

 // 时间戳转天时分秒
 export function timestampToTime(mss) {
    var days = parseInt(mss / (1000 * 60 * 60 * 24));
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    // var seconds = ((mss % (1000 * 60)) / 1000).toFixed(0);
    // + seconds + ' 秒 ';
    return days + ' 天 ' + hours + ' 小时 ' + minutes + ' 分钟 '
}
  export function extra_info(obj) {
    let str = '';
    if(obj){
        for (const [key, value] of Object.entries(obj)) {
            // str += `${key}: ${value}; `
            str +=value+'/'
          }
          str = str.slice(0, -1);
    }
   
    return str
  }
  export function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = addZero(date.getMonth() + 1);
    const day = addZero(date.getDate());
    const hours = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
   
  function addZero(value) {
    return value < 10 ? `0${value}` : value;
  }

